import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../examples/LayoutContainers/DashboardLayout';
import MDBox from '../../components/MDBox';
import { Backdrop, Card, CircularProgress, Grid, Icon, InputLabel, MenuItem, Select, FormControl, Switch, FormControlLabel } from '@mui/material';
import MDTypography from '../../components/MDTypography/index';
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import moment from 'jalali-moment'
import Footer from 'examples/Footer';
import { getReservedCounter, getCalendar, getAutoReservation, deleteAutoReservation, getReservationByDate } from '../../api/routes';
import { Link } from 'react-router-dom';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import { Modal } from '@mui/material';
import { getTimeSpan, addAutoReservation, getTimeSpanCounter } from '../../api/routes';
import MDButton from 'components/MDButton';
import useStyle from './style';
import { toast } from "react-toastify";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '700px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius:4,
    p: 4,
    maxHeight: 600,
    overflowY: 'auto',
    "@media (max-width: 700px)": {
        width: '95%',
    }
};

export default function Dashboard() {
    const classes = useStyle();
    const m = moment();
    const [reservedTimesList, setReservedTimesList] = useState([])
    const [reservationDay, setReservationDay] = useState([])
    const [clickedDayId, setClickedDayId] = useState();
    const [timeSpanId, setTimeSpanId] = useState([]);
    const [timeSpanData, setTimeSpanData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [autoReservation, setAutoReservation] = useState([])
    const [open, setOpen] = useState(false);
    const [isClickedDates, setIsClickedDates] = useState(false)
    const [scenarioList, setScenarioList] = useState([])
    const [isShowTimeSpan, setIsShowTimeSpan] = useState(false);
    const [timeSpanList, setTimeSpanList] = useState([])
    const [trigger, setTrigger] = useState(null);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useEffect(() => {
        setLoading(true)
        getCalendar(m?.locale('fa')?.format('YYYYMMDD'), (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setReservationDay(data)
        })
        getReservedCounter(m?.locale('fa')?.format('YYYYMMDD'), (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setReservedTimesList(data)
        })
        getTimeSpan(1, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setTimeSpanData(data)
        })
        getTimeSpanCounter(m?.locale('fa')?.format('YYYYMMDD'), (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else {
                setLoading(false)
                return setTimeSpanList(data)
            }
        })
    }, [])

    useEffect(() => {
        getAutoReservation((isOk, data) => {
            if (!isOk) {
                if (data.status === 403) {
                    sessionStorage.clear()
                    window.location.reload();
                } else return toast.error(data.data.message)
            }
            else return setAutoReservation(data)
        },trigger!=null)
    }, [trigger]);
    const reservedDays = reservedTimesList.map(item => item.reservationDate)

    const timeSpanDays = timeSpanList.map(item => item.reservationDate)

    const days = {
        "شنبه": 1,
        "یکشنبه": 2,
        "دوشنبه": 3,
        "سه شنبه": 4,
        "چهارشنبه": 5,
        "پنج شنبه": 6,
        "جمعه": 7,
    }
    const autoReservedGrid = {
        "6": 1,
        "0": 2,
        '1': 3,
        "2": 4,
        "3": 5,
        "4": 6,
        "5": 7
    }

    const autoReservedDays = [
        {
            id: 6,
            day: "شنبه"
        },
        {
            id: 0,
            day: "یکشنبه"
        },
        {
            id: 1,
            day: "دوشنبه"
        },
        {
            id: 2,
            day: "سه شنبه"
        },
        {
            id: 3,
            day: "چهارشنبه"
        },
        {
            id: 4,
            day: "پنج شنبه"
        },
        {
            id: 5,
            day: "جمعه"
        },
    ]

    const addAutoReservations = () => {
        if (timeSpanId) {
            const data = {
                timeSpanId,
                dayId: clickedDayId
            }
            addAutoReservation(data, (isOk, data) => {
                if (!isOk) return toast.error(data.message);
                else{
                  toast.success("سناریو جدید اضافه شد!")
                  setTrigger(Math.random())
                }
            })
        } else return toast.error('سناریو را انتخاب کنید')
    }
    const deleteAutoReservations = (autoReservationId) => {
        deleteAutoReservation(autoReservationId, (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else {
              toast.success("سناریو حذف شد!")
              setTrigger(Math.random())
            }
        })
    }
    const clickedReservationDate = (reservationDate) => {
        setLoading(true)
        getReservationByDate(reservationDate.split('/').join(''), (isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else {
                setIsClickedDates(true)
                setLoading(false)
                handleOpen()
                return setScenarioList(data)
            }
        })
    }

    return (
        <>
            <DashboardLayout>
                <MDBox pt={2} mb={6}>
                    <Grid container spacing={6}>
                        <Grid item xs={12}>
                            <Card>
                                <MDBox
                                    mx={2}
                                    mt={-3}
                                    py={3}
                                    px={2}
                                    variant="gradient"
                                    bgColor="info"
                                    borderRadius="lg"
                                    coloredShadow="info"
                                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                >
                                    <MDTypography variant="h6" color="white">
                                        داشبورد
                                    </MDTypography>
                                    <DashboardNavbar />
                                </MDBox>
                                <p style={{ fontSize: '14px', paddingTop: '1.5rem', textAlign: 'center', fontWeight: 'bold' }}>الگو نوبت دهی خودکار</p>
                                <MDBox pt={3} px={3} className={classes.autoReserveParent}>
                                    {autoReservedDays.map(item => <p onClick={() => { setClickedDayId(item.id); handleOpen(); setIsClickedDates(false) }} className={classes.autoReserveDayTitle} key={item.id}>{item.day}</p>)}
                                </MDBox>
                                <div style={{ paddingTop: '3rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <FormControlLabel control={<Switch checked={isShowTimeSpan} color={"success"} onChange={(event) => setIsShowTimeSpan(event.target.checked)} />} label="نمایش سناریو ها" />
                                </div>
                                <MDBox py={2} px={3} className={classes.datesParent}>
                                    {isShowTimeSpan === false && reservationDay.map((item, index) => <section key={index} className={classes.date}
                                        style={{ gridColumn: days[item.NDay], background: reservedDays.includes(parseInt(item.CDate.split('/').join(''))) ? 'rgba(62, 205, 219,0.1)' : '#fff', border: item.Holiday == 1 ? '1px solid #fa3668' : (reservedDays.includes(parseInt(item.CDate.split('/').join(''))) || timeSpanDays.includes(parseInt(item.CDate.split('/').join('')))) ? '2px solid #3ecddb' : '1px solid #dee2e6',  }}>
                                        <Link to={`/ReservedList?date=${item.CDate.split('/').join('')}`}>
                                            <p className={classes.dayText} style={{ fontWeight: reservedDays.includes(parseInt(item.CDate.split('/').join(''))) ? 'bold' : 'normal' }}>{item.CDay}</p>
                                            <p className={classes.monthText}>{item.NMonth}</p>
                                            {reservedDays.includes(parseInt(item.CDate.split('/').join(''))) && <div className={classes.reservedCounter}>{reservedTimesList[reservedTimesList.findIndex(element => element.reservationDate === parseInt(item.CDate.split('/').join('')))].counter}</div>}
                                        </Link>
                                    </section>)}
                                    {isShowTimeSpan === true && reservationDay.map((item, index) => <section key={index} className={classes.date}
                                        onClick={() => timeSpanDays.includes(parseInt(item.CDate.split('/').join(''))) && clickedReservationDate(item.CDate)}
                                        style={{ cursor: timeSpanDays.includes(parseInt(item.CDate.split('/').join(''))) ? 'pointer' : 'default', gridColumn: days[item.NDay], background: timeSpanDays.includes(parseInt(item.CDate.split('/').join(''))) ? '#dcfce7' : '#fff', border: item.Holiday == 1 ? '1px solid #fa3668' : timeSpanDays.includes(parseInt(item.CDate.split('/').join(''))) ? '2px solid #4ade80' : '1px solid #dee2e6' }}>
                                        <p className={classes.dayText} style={{ fontWeight: timeSpanDays.includes(parseInt(item.CDate.split('/').join(''))) ? 'bold' : 'normal' }}>{item.CDay}</p>
                                        <p className={classes.monthText}>{item.NMonth}</p>
                                        {timeSpanDays.includes(parseInt(item.CDate.split('/').join(''))) && <div className={classes.reservedCounterScenario}>{timeSpanList[timeSpanList.findIndex(element => element.reservationDate === parseInt(item.CDate.split('/').join('')))].counter}</div>}
                                    </section>)}
                                </MDBox>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
                <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Footer />
                <Modal open={open} onClose={handleClose}>
                    <MDBox sx={style}>
                        {isClickedDates === false && <section style={{ marginBottom: '3rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <FormControl sx={{ width: '300px' }}>
                                <InputLabel>شناسه سناریو</InputLabel>
                                <Select value={timeSpanId} onChange={(event) => setTimeSpanId(event.target.value)} label="شناسه سناریو" sx={{ height: '44.3px' }}>
                                    {timeSpanData.map((item) =>
                                        <MenuItem key={item.timeSpanId} value={item.timeSpanId}>{item.fullNameGroup} - {item.startTime}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                            <MDButton onClick={addAutoReservations} variant="gradient" color="info">
                                ثبت سناریو
                            </MDButton>
                        </section>}
                        {isClickedDates && <p>سناریو ها</p>}
                        {isClickedDates === false ? autoReservation.filter(item => item.dayId == clickedDayId).map((item) => <div key={item.autoReservationId}>
                            <section style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px', marginTop: '1rem' }}>
                                <p style={{ width: '200px' }}>{item.fullNameGroup}</p>
                                <p>{item.startTime + " الی " + item.endTime}</p>
                                <p>{item.patientNumber + ' نفر'}</p>
                                <Icon style={{ color: 'red' }} onClick={() => deleteAutoReservations(item.autoReservationId)}>delete</Icon>
                            </section>
                            <hr style={{ width: '100%', color: '#999999', marginTop: '0.5rem' }} />
                        </div>
                        ) : scenarioList.map((item, index) =>
                            <div key={item.reservationDayId}>
                                <section style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '14px', marginTop: '1rem' }}>
                                    <p style={{ width: '200px' }}>{item.fullNameGroup}</p>
                                    <p>{item.startTime + " الی " + item.endTime}</p>
                                    <p>{item.patientNumber + ' نفر'}</p>
                                </section>
                                {scenarioList.length - 1 !== index && <hr style={{ width: '100%', color: '#999999', marginTop: '0.5rem' }} />}
                            </div>
                        )}
                    </MDBox>
                </Modal>
            </DashboardLayout>
        </>
    )
}
